import { create } from 'zustand';
import { waitForPermissionAndRun } from '@utils/useWaitForPermissions';

export const useCustomerCreateStore = create((set) => ({
  isOpen: false,
  payload: {},
  callback: null,

  openCustomerCreate: (payload, callback = null) => {
    waitForPermissionAndRun(() => {
      set({ isOpen: true, payload, callback });
    });
  },

  close: (result) =>
    set((state) => {
      if (state.callback) state.callback(result);
      return { isOpen: false, payload: {}, callback: null };
    }),
}));

// 🔥 Now supports callback
export const openCustomerCreate = (payload, callback = null) => {
  const store = useCustomerCreateStore.getState();
  store.openCustomerCreate(payload, callback);
};

export const closeCustomerCreate = () => {
  const store = useCustomerCreateStore.getState();
  store.close();
};
